import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { ProfileComponent } from '@app/shared-profile/components/profile-container/profile.component'
import { ProfGuard } from '@app/core/_guards'
import { ProfileInfoComponent } from '@app/shared-profile/components/profile-info/profile-info.component'
import { UserResolver } from '@app/core/_resolvers/user.resolver'
import { AvailabilityComponent } from './components/availability/availability.component'
import { MemberProfileResolver } from '@app/core/_resolvers/member-profile.resolver'

export const PAGE_NAME_USER_SEE_AVAILABILITY = 'User Profile: See Availability'
export const PAGE_NAME_USER_PROFILE = 'User Profile'

const routes: Routes = [
    {
        path: '',
        component: ProfileComponent,
        resolve: {
            currentUser: UserResolver,
            memberProfile: MemberProfileResolver,
        },
        canActivate: [ProfGuard],
        children: [
            {
                path: '',
                component: ProfileInfoComponent,
                data: { robots: 'noindex, nofollow', pageName: PAGE_NAME_USER_PROFILE },
            },
            {
                path: 'availability',
                component: AvailabilityComponent,
                data: { robots: 'noindex, nofollow', pageName: PAGE_NAME_USER_SEE_AVAILABILITY },
            },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class UserProfileRoutingModule {}
